import Masonry from 'masonry-layout';

var grid = document.querySelector('.masonry-grid');
if (grid) {
	var msnry = new Masonry(grid, {
		itemSelector: '.masonry-grid-item'
	});
}
